




import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const JobGrid = () => {
  const [jobs, setJobs] = useState([]);
  const [activeFilter, setActiveFilter] = useState('Recent Jobs');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}job/alljob2?page=1&limit=10`);
        const data = await response.json();
        const sortedJobs = Array.isArray(data) ? data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)) : [];
        setJobs(sortedJobs);
      } catch (error) {
        console.error("Error fetching jobs:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchJobs();
  }, []);

  const getTimeAgo = (date) => {
    const now = new Date();
    const postedDate = new Date(date);
    const monthsAgo = Math.floor((now - postedDate) / (1000 * 60 * 60 * 24 * 30));
    return `${monthsAgo} month${monthsAgo !== 1 ? 's' : ''} ago`;
  };

  const filteredJobs = jobs
    .filter(job => {
      if (activeFilter === 'Recent Jobs') return true;
      return job.workType.toLowerCase() === activeFilter.toLowerCase();
    })
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    .slice(0, 4);

  if (loading) return <div className="text-center py-4">Loading...</div>;

  return (
    <div className="bg-white p-4 sm:p-6 w-auto flex flex-col flex-wrap px-4 lg:px-28"> {/* Added px-4 lg:px-8 for left/right padding */}
      <div className="flex flex-col sm:flex-row justify-between items-center mb-4">
        <div className="flex flex-row flex-wrap sm:flex-row justify-between items-center">
          <div className="ml-50 items-center grid grid-cols-3 gap-3 w-full sm:flex sm:flex-row sm:gap-0 sm:w-auto "> {/* Removed ml-30 typo, adjusted to ml-0 */}
            <div className="w-full flex justify-center sm:w-auto">
              <button
                className={`w-full px-2 py-2 rounded-l ${activeFilter === 'Recent Jobs' ? 'bg-orange-500 text-white' : 'bg-gray-200 text-gray-700'} hover:bg-orange-500 hover:text-white transition sm:mr-4 sm:mb-3 sm:w-auto sm:px-4`} 
                onClick={() => setActiveFilter('Recent Jobs')}
              >
                Recent Jobs
              </button>
            </div>
            <div className="w-full flex justify-center sm:w-auto">
              <button
                className={`w-full px-2 py-2 ${activeFilter === 'Part-Time' ? 'bg-orange-500 text-white' : 'bg-gray-200 text-gray-700'} hover:bg-orange-500 hover:text-white transition sm:mr-4 sm:mb-3 sm:w-auto sm:px-4`}
                onClick={() => setActiveFilter('Part-Time')}
              >
                Part time
              </button>
            </div>
            <div className="w-full flex justify-center sm:w-auto">
              <button
                className={`w-full px-2 py-2 rounded-r ${activeFilter === 'Full-Time' ? 'bg-orange-500 text-white' : 'bg-gray-200 text-gray-700'} hover:bg-orange-500 hover:text-white transition sm:mr-4 sm:mb-3 sm:w-auto sm:px-4`}
                onClick={() => setActiveFilter('Full-Time')}
              >
                Full Time
              </button>
            </div>
            <div className="w-full flex justify-center sm:w-auto">
              <button
                className={`w-full px-2 py-2 rounded-r ${activeFilter === 'Contract' ? 'bg-orange-500 text-white' : 'bg-gray-200 text-gray-700'} hover:bg-orange-500 hover:text-white transition sm:mr-4 sm:mb-3 sm:w-auto sm:px-4`}
                onClick={() => setActiveFilter('Contract')}
              >
                Contract
              </button>
            </div>
            <div className="w-full flex justify-center sm:w-auto">
              <button
                className={`w-full px-2 py-2 rounded-r ${activeFilter === 'Freelance' ? 'bg-orange-500 text-white' : 'bg-gray-200 text-gray-700'} hover:bg-orange-500 hover:text-white transition sm:mr-4 sm:mb-3 sm:w-auto sm:px-4`}
                onClick={() => setActiveFilter('Freelance')}
              >
                Freelance
              </button>
            </div>
            <div className="w-full flex justify-center sm:w-auto">
              <button
                className={`w-full px-2 py-2 rounded-r ${activeFilter === 'Remote' ? 'bg-orange-500 text-white' : 'bg-gray-200 text-gray-700'} hover:bg-orange-500 hover:text-white transition sm:mr-4 sm:mb-3 sm:w-auto sm:px-4`}
                onClick={() => setActiveFilter('Remote')}
              >
                Remote
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className=" grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 px-4 lg:px-28"> {/* Added px-4 lg:px-8 to match outer padding */}
        {filteredJobs.map((job, index) => (
          <div key={index} className="bg-gray-50 p-4 border border-gray-200 rounded-lg shadow-sm">
            <div className="flex items-start justify-between">
              <div>
                <h3 className="text-lg font-semibold text-gray-900">{job.jobTitle}</h3>
                {/* <p className="text-sm text-gray-600">{job.employer?.name || 'Unknown Employer'}</p> */}
              </div>
              <span className="text-sm text-gray-500">{job.workType}</span>
            </div>
            <div className="mt-2 text-sm text-gray-600">
              <p className='font-sembold'><span className="text-orange-500">★</span> {job.localGovernment}, {job.state}</p>
              <p>Experience Level: {job.experienceLength}</p>
              <p>Posted: {getTimeAgo(job.createdAt)}</p>
               <span className='font-semibold'>Salary: {job.salary} {job.currency}</span>
            </div>
            <div className="mt-2 text-sm text-gray-600 flex justify-between">
             
<div className="mt-2 text-sm text-gray-600 flex justify-end">
  <Link
    to={`/job/${job._id}`}
    className="px-6 py-2.5 bg-orange-500 text-white font-medium rounded-md hover:bg-orange-600 transition-colors shadow-sm"
  >
    Apply Now
  </Link>
</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default JobGrid;